//eslint-disable
import React from 'react';
import { ArcaChangePassword } from '../../code/ArcaChangePassword';
import { ArcaField } from '../../code/ArcaField';
import { ArcaHttpClientLogin } from '../../code/ArcaHttpClientLogin';
import { ArcaPageFieldState } from '../../code/ArcaPageFieldState';
import { ArcaSecurity } from '../../code/ArcaSecurity';
import { ArcaLink } from '../controls/Fields/ArcaLink';
import { InputField } from '../controls/Fields/InputField';
import { StatusBar } from '../controls/StatusBar';
import { ArcaComponent } from './ArcaComponent';

export class ChangePassword extends ArcaComponent {

    constructor(props) {
        super(props);

        var dataState = new ArcaChangePassword()
        if (ArcaSecurity.IsLoggedIn) {
            dataState.Email = ArcaSecurity.Email
        }
        var formState = this.buildFields(dataState);

        this.state = {
            email: null,
            formState: formState,
            newPassword: null,
            oldPassword1: null,
            oldPassword2: null,
            statusText: null,
            isError: false,
            dataState: dataState,
            passwordChanged: false
        };
    }


    render() {
        let { formValid, formState, isError, statusText} = this.state

        return (
            <div>
                <div>
                    <h1 id="tabelLabel">Change Password</h1>
                    <p>Please enter your email address, old password and new password in order to change the password.</p>

                    <br />

                    {formState.Fields.map((f, k) =>
                        <InputField
                            label={f.FieldLabel}
                            fieldname={f.FieldName}
                            key={k}
                            regularExpression={f.Validation}
                            warnText='Invalid format'
                            mandatory={f.IsMandatory}
                            value={f.Value}
                            onUpdate={this.onUpdate.bind(this)}
                            fieldValid={f.IsValid}
                            fieldClass='simpleInputField' />

                    )}

                    <ArcaLink
                        width='100%'
                        onClick={this.onSubmit.bind(this)}
                        disabled={!formValid }
                        text='Submit the change' />
                    <StatusBar isError={isError} message={statusText} />
                </div>
            </div>
        );
    }


    onUpdate(value, isValid, fieldName) {
        let { formState } = this.state
        formState.GetField(fieldName).Value = value;
        formState.GetField(fieldName).IsValid = isValid;

        var dataState = this.state.dataState
        dataState[fieldName] = value

        const fieldsMatch = formState.GetField('NewPassword1').Value === formState.GetField('NewPassword2').Value

        this.setState({
            dataState: dataState,
            disabled: false,
            formValid: this.state.formState.IsValid && fieldsMatch
        });
    }

    async onSubmit() {

        try {

            ArcaHttpClientLogin.ChangePasswordAsync(
                this.state.dataState,
                    (user => {
                        this.setState({
                            formValid: false,
                            statusText: "Password change successful!",
                            isError: false,
                            passwordChanged: true
                        })
                    })/*.bind(this)*/,
                (message => {
                    this.setState({
                        formValid: true,
                        statusText: message,
                        isError: true
                    })
                })/*.bind(this)*/);

            this.setState({
                formValid: true,
                statusText: null,
                isError: false
            });
        }
        catch (error) {
            this.setState({
                formValid: true,
                statusText: error,
            });
        }
    }

    buildFields(data) {
        var formState = new ArcaPageFieldState();
        if (!ArcaSecurity.IsLoggedIn)
            formState.AddField(new ArcaField("Email Address", "Email", data.Email, true, true, 'text', 'email'));
        formState.AddField(new ArcaField("Old password", "OldPassword", data.OldPassword, false, true, 'text', 'password'));
        formState.AddField(new ArcaField("New password", "NewPassword1", data.NewPassword1, false, true, 'text', 'password'));
        formState.AddField(new ArcaField("New password again", "NewPassword2", data.NewPassword2, false, true, 'text', 'password'));

        return formState;
    }
}
